module.exports = __webpack_public_path__ + "img/shopNum6.1fccf83c.png";